import PropTypes from 'prop-types';

/*
utils for dealing with cssClasses
*/

/*
proptype definitions for CSS classes
*/
const classNamePropTypes = PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf([PropTypes.string])]);

/*
given array of original css class arrays
and new css classes
return new array with combined CSS classes, or the original aray
*/
function addClassNames(newClasses, allClasses) {
  if (newClasses && typeof newClasses === 'string') return allClasses.concat([newClasses]);
  if (newClasses && Array.isArray(newClasses)) return allClasses.concat(newClasses);
  return allClasses;
}

var classNames = /*#__PURE__*/Object.freeze({
  __proto__: null,
  classNamePropTypes: classNamePropTypes,
  addClassNames: addClassNames
});

export { addClassNames as a, classNames as b, classNamePropTypes as c };
